// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"2f27a936","455":"bc25707a","488":"e8f622ba"}[chunkId] + ".chunk.js";
};